import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d22e7d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inspection" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"inspection_list\" data-v-9d22e7d8><div class=\"inspection_list_item\" data-v-9d22e7d8><span data-v-9d22e7d8>检验类型</span><div class=\"right\" data-v-9d22e7d8><div class=\"right_item active\" data-v-9d22e7d8>完工检</div></div></div></div><div class=\"x\" data-v-9d22e7d8></div>", 2)
const _hoisted_4 = { class: "inspection_list" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检验工单", -1))
const _hoisted_6 = { class: "right1" }
const _hoisted_7 = {
  key: 0,
  class: "inspection_list_item"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "计划数量", -1))
const _hoisted_9 = { class: "right1" }
const _hoisted_10 = { style: {"color":"black"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "x" }, null, -1))
const _hoisted_12 = { class: "inspection_list" }
const _hoisted_13 = { class: "inspection_list_item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "良品数", -1))
const _hoisted_15 = { class: "right1" }
const _hoisted_16 = {
  key: 0,
  class: "dw"
}
const _hoisted_17 = { class: "inspection_list_item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良数量", -1))
const _hoisted_19 = { class: "right1" }
const _hoisted_20 = {
  key: 0,
  class: "dw"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良说明", -1))
const _hoisted_22 = { class: "right1" }
const _hoisted_23 = { class: "inspection_footer" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_25 = [
  _hoisted_24
]

import { ref, reactive, onMounted, onActivated } from 'vue'
    import { useRouter } from "vue-router"
    import { Toast } from 'vant'
    import { REGULAR } from '@/utils/utils'
    import { Attribute } from '@/enum'
    import { createStandard } from '@/apis/QualityAPI'
    import { checkAllList, getListByCondition, toolingQueryById } from "@/apis/WorkOrderAPI"
    import Tooling from '@/components/common/Tooling.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const router = useRouter()

    let gzShow = ref<boolean>(false)

    let gzShow1 = ref<boolean>(false)

    let data = reactive<any>({
        info: {},
        show1: false,
        columns: [],
        columns1: []
    })

    let form = reactive({
        status: '2',
        gdid: '',
        gdmc: '',
        jygz: '',
        jygzmc: '',
        hgsl: 0,
        blsl: 0,
        blgz: '',
        blgzmc: '',
        blsm: '',
        dw: ''
    })

    let status = ref<Array<object>>([
        { id: '0', name: '巡线', active: true },
        { id: '1', name: '巡检', active: false },
        { id: '2', name: '完工检', active: false }
    ])

    // 关闭不良工装
    const close = () => {
        gzShow.value = false
    }

    // 关闭工装
    const close1 = () => {
        gzShow1.value = false
    }

    // 获取不良工装数据
    const getValue = (item: any) => {
        form.blgzmc = item.code
        form.blgz = item.id
        gzShow.value = false
    }

    // 获取工装数据
    const getValue1 = (item: any) => {
        form.dw = item.umodelData
        form.jygz = item.id
        form.jygzmc = item.code
        gzShow1.value = false
    }

    // 打开检验工装
    const openGZ = () => {
        gzShow1.value = true
    }

    // 去选择设备
    const jumpGD = () => {
        router.push({ name: 'selectWorkOrder', query: { type: 2 } })
    }

    const openBL = () => {
        data.show1 = true
    }

    const openBLGZ = () => {
        gzShow.value = true
    }

    const onConfirm1 = (value: any): void => {
        form.blsm = value.text
        data.show1 = false
    }

    const onCancel1 = () => {
        data.show1 = false
    }

    // 切换状态
    const changeItem = (i: number, id: string): void => {
        status.value.forEach((item: any, index: number) => {
            item.active = i === index;
        })
        form.status = id
    }

    // 提交
    const submit = () => {
        if (!form.gdid) return Toast.fail({ message: '工单不能为空' })
        // if (!form.jygz) return Toast.fail({ message: '检验工装不能为空' })
        if (form.hgsl || form.blsl) {
            if (form.hgsl) {
                if (form.dw == '0') {   // 整数
                    if (!REGULAR.positiveInteger.test(form.hgsl as never)) return Toast.fail({ message: '良品数量只能为正整数' })
                } else if (form.dw == '1') {    // 小数
                    if (!REGULAR.number.test(form.hgsl as never)) {
                        return Toast.fail({ message: '良品数量只能为正整数或四位小数' })
                    }
                }
            }
            if (form.blsl) {
                if (form.dw == '0') {   // 整数
                    if (!REGULAR.positiveInteger.test(form.blsl as never)) return Toast.fail({ message: '不良数量只能为正整数' })
                } else if (form.dw == '1') {    // 小数
                    if (!REGULAR.number.test(form.blsl as never)) {
                        return Toast.fail({ message: '不良数量只能为正整数或四位小数' })
                    }
                }
            }
        } else {
            return Toast.fail({ message: '良品和不良不能同时为空' })
        }
        let total = (form.hgsl ? form.hgsl : 0) + (form.blsl ? form.blsl : 0)
        if (total > data.info.planNum) {
            return Toast.fail({ message: '合格不良相加不能超过计划数量' })
        }
        if (Number(form.blsl) > 0) {
            // if (!form.blgz) return Toast.fail({ message: '不良工装不能为空' })
            if (!form.blsm) return Toast.fail({ message: '不良说明不能为空' })
        }
        createStandard({
            workorderId: form.gdid,
            // appliancesId: form.jygz,
            qualifiedNum: form.hgsl ? form.hgsl : 0,
            unqualifiedNum: form.blsl ? form.blsl : 0,
            // qualifiedApplianceId: form.blgz,
            checkInfo: form.blsm,
            checkType: form.status
        }).then(res => {
            if (res.code === 200) {
                Toast.success({ message: '检验成功！', duration: 2000, forbidClick: true })
                setTimeout(() => {
                    router.go(-1)
                }, 2000)
            }
        })
    }

    // 不良原因数据
    const checkAllLists = () => {
        checkAllList({ bmodelCateType: '3' })
            .then(res => {
                if (res.code === 200) {
                    res.data.forEach((item: any) => {
                        data.columns1.push({ text: item.combinationName, id: item.id })
                    })
                }
            })
    }

    // 查询不良/报废工装
    const getListByConditions1 = () => {
        data.columns2 = []
        getListByCondition({
            smodelLabel: 'APPLIANCE_OFFTEST,APPLIANCE_USELESS'
        }).then(res => {
            if (res.code === 200) {
                res.data.forEach((item: any) => {
                    data.columns2.push({ text: '[' + item.smodelCode  + '] ' + item.code, id: item.id })
                })
            }
        })
    }

    // 获取所有工装
    const toolingQueryByIds = () => {
        data.columns3 = []
        toolingQueryById({})
            .then(res => {
                if (res.code === 200) {
                    res.data.forEach((item: any) => {
                        data.columns3.push({ text: item.code, id: item.id })
                    })
                }
            })
    }

    onMounted(() => {
        checkAllLists()
        // /productionInspection/manualInspection
        // getListByConditions1()
        // toolingQueryByIds()
    })

    onActivated(() => {
        let res: any = localStorage.getItem('workOder')
        if (res) {
            form.gdmc = JSON.parse(res).mmodel.name + '-' + JSON.parse(res).pgmodel.name
            form.gdid = JSON.parse(res).id
            data.info = JSON.parse(res)
            localStorage.removeItem('workOder')
        }
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "inspection_list_item",
        onClick: jumpGD
      }, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", {
            style: _normalizeStyle(_unref(form).gdmc ? 'color: #000;' : '')
          }, _toDisplayString(_unref(form).gdmc ? _unref(form).gdmc : '点击选择检验工单'), 5),
          _createVNode(_component_van_icon, {
            name: "arrow",
            color: "#999999",
            size: "18"
          })
        ])
      ]),
      (_unref(form).gdmc)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(data).info.planNum) + _toDisplayString(_unref(data).info.umodel ? _unref(data).info.umodel.name : ''), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).hgsl) = $event)),
            placeholder: "0"
          }, null, 512), [
            [_vModelText, _unref(form).hgsl]
          ]),
          (_unref(data).info.umodel)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(data).info.umodel.name), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).blsl) = $event)),
            placeholder: "0"
          }, null, 512), [
            [_vModelText, _unref(form).blsl]
          ]),
          (_unref(data).info.umodel)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(data).info.umodel.name), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _withDirectives(_createElementVNode("div", {
        class: "inspection_list_item",
        onClick: openBL
      }, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", {
            style: _normalizeStyle(_unref(form).blsm ? 'color: #000;' : '')
          }, _toDisplayString(_unref(form).blsm ? _unref(form).blsm : '点击选择不良原因'), 5),
          _createVNode(_component_van_icon, {
            name: "arrow",
            color: "#999999",
            size: "18"
          })
        ])
      ], 512), [
        [_vShow, _unref(form).blsl > 0]
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "inspection_footer_sub",
        onClick: submit
      }, _hoisted_25)), [
        [_directive_preventReClick]
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _unref(data).show1,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_unref(data).show1) = $event)),
      position: "bottom",
      round: "",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "请选择不良说明",
          columns: _unref(data).columns1,
          onConfirm: onConfirm1,
          onCancel: onCancel1
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(Tooling, {
      show: _unref(gzShow1),
      classification: true,
      statusname: '1,2,3',
      attribute: _unref(Attribute).HG,
      onClose: close1,
      onValue: getValue1
    }, null, 8, ["show", "attribute"]),
    _createVNode(Tooling, {
      show: _unref(gzShow),
      attribute: _unref(Attribute).BF + ',' + _unref(Attribute).BL,
      onClose: close,
      onValue: getValue
    }, null, 8, ["show", "attribute"])
  ]))
}
}

})